// ##############################
// // // Tasks for TasksCard - see Dashboard view
// #############################

    const colors = {

      category: (category) => {
        switch (category) {
        case 'game':
        case 'games':
            return 'orange';
        case 'marketplace':
        case 'marketplaces':
            return 'green';
        case 'pyramid':
        case 'pyramids':
        case 'casino':
        case 'casinos':
            return 'red';
        default:
            return 'blue';
        }
    }
  }



module.exports = {
  // these 3 are used to create the tasks lists in TasksCard - Dashboard view
  colors
 // website,
//  server
};



// WEBPACK FOOTER //
// ./src/variables/general.jsx